export const start = (fn, seconds) => {
  const interval = setInterval(fn, seconds * 1000);

  return {
    stop: () => {
      clearInterval(interval);
    },
  };
};
